export const enum USER {
  UNDERWRITER = "KamKomBankUnderwriter", // Андеррайтер
  LEAD = "KamKomBankLead", // Руководитель
  EMPLOYEE = "KamKomBankBankEmployee", //Сотрудник сопровождения
}
